/****************************************************
 * Module Name:  addLocationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CountryProxy from "../../utility/proxy/manager/countryProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import Select from "react-select";
import Constants from "../../utility/constants";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import logo from '../../images/pansuriya.jpg'
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddLocationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newlocation: this.props.editOperation ? this.props.sourceData.name : "",
      newcountry: this.props.editOperation
        ? {
          value: this.props.sourceData.country_id,
          label: this.props.sourceData.country,
        }
        : { value: 0, label: "Error" },
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newaddress: this.props.editOperation ? this.props.sourceData.address : "",
      newpincode: this.props.editOperation ? this.props.sourceData.pincode : "",
      newphone: this.props.editOperation ? this.props.sourceData.phone : "",
      newmobile: this.props.editOperation ? this.props.sourceData.mobile : "",
      newfax: this.props.editOperation ? this.props.sourceData.fax : "",
      newnotify_user_on_signup: this.props.editOperation ? this.props.sourceData.notify_user_on_signup : "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",

      showError: false,

      validateLocationPresentSpinner: false,
      showValidationMessage: false,
      locationAvailable: true,

      countries: [],
      countriesOptions: [],
      showCountryLoadSpinner: true,

      locationValidationError: "",
      pincodeValidationError: "",
      mobileValidationError: "",
    };

    this.getCountryList(false);
  }

  getCountryList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showCountryLoadSpinner: true });
    CountryProxy.GetAllCountry((response) => this.setCountryData(response));
  };

  setCountryData = (response) => {
    let cOptions = [];
    let nNewCountry = this.state.newcountry;

    response.map((country) => {
      let iOption = { value: country.id, label: country.name };
      cOptions.push(iOption);

      if (country.id === this.state.newcountry.value) nNewCountry = iOption;

      return true;
    });

    //During new creation option select first one as default
    if (nNewCountry.value === 0 && cOptions.length > 0)
      nNewCountry = cOptions[0];

    this.setState({
      countries: response,
      countriesOptions: cOptions,
      newcountry: nNewCountry,
      showCountryLoadSpinner: false,
    });
  };

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newlocation,
      description: this.state.newdescription,
      country_id: this.state.newcountry.value,
      address: this.state.newaddress,
      pincode: this.state.newpincode,
      phone: this.state.newphone,
      mobile: this.state.newmobile,
      fax: this.state.newfax,
      notify_user_on_signup: this.state.newnotify_user_on_signup,
      seq: this.state.newseq
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateLocationPresent = (locationEntered) => {
    if (!locationEntered || locationEntered.trim() === "") return;

    this.setState({
      validateLocationPresentSpinner: true,
    });

    LocationProxy.CheckLocationAvailable(locationEntered, (response) => {
      //if we got response that means location is present at backend
      if (response) {
        //LocationName already present
        this.setState({
          validateLocationPresentSpinner: false,
          showValidationMessage: true,
          locationAvailable: false,
        });
      } else {
        //LocationName not available, so can be used
        this.setState({
          validateLocationPresentSpinner: false,
          showValidationMessage: true,
          locationAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      (this.state.mobileValidationError.length > 0 ||
        this.state.pincodeValidationError.length > 0)
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.locationAvailable ||
        this.state.mobileValidationError.length > 0 ||
        this.state.pincodeValidationError.length > 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add location validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Location" : "Add New Location"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Location Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Location <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newlocation}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Location (required)"
                          placeholder="Enter Location"
                          value={this.state.newlocation}
                          autoFocus
                          onBlur={(e) =>
                            this.validateLocationPresent(this.state.newlocation)
                          }
                          onChange={(e) =>
                            this.setState({
                              newlocation: e.target.value,
                              showValidationMessage: false,
                              locationValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Location Cannot be Empty",
                            })
                          }
                          helperText={this.state.locationValidationError}
                          error={this.state.locationValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateLocationPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.locationAvailable ? (
                        <font color="green">Location available</font>
                      ) : (
                        <font color="red">Location not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Country</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <Select menuPlacement="auto"
                              blurInputOnSelect={false}
                              className="basic-single"
                              classNamePrefix="select"
                              value={this.state.newcountry}
                              isSearchable={true}
                              name="Country"
                              styles={Constants.Styles}
                              menuPortalTarget={document.body}
                              options={this.state.countriesOptions}
                              onChange={(selectedOption) =>
                                this.setState({ newcountry: selectedOption })
                              }
                            />
                          </td>
                          <td>
                            {this.state.showCountryLoadSpinner ? (
                              <CircularProgress
                                size="1em"
                                sx={{ mt: 1.5, ml: 0.7 }}
                              />
                            ) : (
                              <Tooltip title="Reload">
                                <RefreshOutlinedIcon
                                  color="primary"
                                  fontSize="medium"
                                  onClick={() => this.getCountryList(true)}
                                  sx={{ cursor: "pointer", mt: 1 }}
                                />
                              </Tooltip>
                            )}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Address</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Address"
                        placeholder="Enter Address"
                        value={this.state.newaddress}
                        onChange={(e) =>
                          this.setState({ newaddress: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Pincode</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Pincode"
                        placeholder="Enter Pincode"
                        value={this.state.newpincode}
                        onChange={(e) =>
                          this.setState({
                            newpincode: e.target.value,
                            pincodeValidationError:
                              e.target.value.length !== 0
                                ? Utility.CheckisNumberGreaterThanZero(
                                  e.target.value
                                )
                                  ? ""
                                  : "Pincode should be a Valid Positive Number"
                                : "",
                          })
                        }
                        helperText={this.state.pincodeValidationError}
                        error={this.state.pincodeValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Phone</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Phone"
                        placeholder="Enter Phone"
                        value={this.state.newphone}
                        onChange={(e) =>
                          this.setState({ newphone: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Mobile</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Mobile"
                        placeholder="Enter Mobile"
                        value={this.state.newmobile}
                        onChange={(e) =>
                          this.setState({
                            newmobile: e.target.value,
                            mobileValidationError:
                              e.target.value.length !== 0
                                ? Utility.CheckIsPhone(e.target.value)
                                  ? ""
                                  : "Mobile should be a Valid Positive Number of 10 Digits"
                                : "",
                          })
                        }
                        helperText={this.state.mobileValidationError}
                        error={this.state.mobileValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Fax</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Fax"
                        placeholder="Enter Fax"
                        value={this.state.newfax}
                        onChange={(e) =>
                          this.setState({ newfax: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Notify User On Signup</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="notify_user_on_signup"
                        placeholder="Enter User to Notify on Signup"
                        value={this.state.newnotify_user_on_signup}
                        onChange={(e) =>
                          this.setState({ newnotify_user_on_signup: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
